import React from 'react'
import {Outlet, useNavigate} from 'react-router-dom'

import {ServicesSidebarNav} from './ServicesSidebarNav'

import {Layout} from '~/components/layout/Layout'

export const ServicesManagementPage: React.FC = () => {
  const navigate = useNavigate()
  const fullPath = '/app/services/'

  return (
    <Layout
      sideNav={
        <ServicesSidebarNav
          fullPath={fullPath}
          onClick={(id) => navigate(`${fullPath}${id}`)}
        />
      }
      navMenu={null}>
      <Outlet />
    </Layout>
  )
}
